import React from 'react';
import { Modal } from 'react-bootstrap';
import iconClose from 'src/assets/icons/icon-close.svg';

interface CustomModalProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  children: React.ReactNode;
  headerText: string;
  headerClassName?: string;
  className?: string;
  footer?: React.ReactNode;
  size?: 'sm' | 'lg' | 'xl';
  backdrop?: 'static' | boolean;
  dialogClassName?: string;
  isCloseBtnRequired?: boolean;
  iconClassName?: string;
}

const CustomModal: React.FC<CustomModalProps> = ({
  setShowModal,
  showModal,
  children,
  headerText,
  headerClassName = '',
  className = '',
  footer,
  size,
  backdrop,
  dialogClassName,
  isCloseBtnRequired = true,
  iconClassName = '',
}) => {
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered={true}
      size={size}
      backdrop={backdrop}
      dialogClassName={dialogClassName}
    >
      <Modal.Header>
        <Modal.Title className={headerClassName}>{headerText}</Modal.Title>
        {isCloseBtnRequired && (
          <img
            className={`close-btn ${iconClassName}`}
            onClick={() => setShowModal(false)}
            src={iconClose}
            alt="close modal"
          />
        )}
      </Modal.Header>
      <Modal.Body className={className}>{children}</Modal.Body>
      {footer && <Modal.Footer>{footer}</Modal.Footer>}
    </Modal>
  );
};

export default CustomModal;
